/**
 * Finishing - Product Selection
 *
 * @since       31.10.2017
 * @version     1.0.0.1
 * @author      e-novinfo
 * @copyright   e-novinfo 2017
 */

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery(document).ready(function() {

    if ( jQuery( '.products-main-lists' ).length > 0 ) {

        /**********/
        /********** PRODUCT SELECTION **********/
        /**********/

        jQuery( document ).on( 'click', '.product-selection-link', function( event ) {
            
            event.preventDefault();

            var items = [];
            var category = jQuery( this ).attr( 'data-category' );

            jQuery.ajax({
                type : "POST",
                async: false,
                url : data_sage_js.ajaxurl,
                dataType: 'json',
                data: {
                    action: 'loadProductSelectionAjax',
                    category: category
                },
                success: function( data ) {

                    if ( data.answer === 1 ) {
                        
                        jQuery( '.product-selection .content' ).empty();
                        jQuery( '.product-selection .content' ).html( data.content );
                        jQuery( '.product-selection' ).fadeIn( 'fast' );
                        
                    } else {

                        jQuery( '.product-selection .content' ).html( '<p>Une erreur s\'est produite ! - 1</p>' );
                        
                    //END else
                    }

                //END success
                },
                error: function () {

                    jQuery( '.product-selection .content' ).html( '<p>Une erreur s\'est produite ! - 2</p>' );

                }

            });

            return false;

        });

        /**********/
        /********** CLOSE PRODUCT SELECTION **********/
        /**********/

        jQuery( document ).on( 'click', '.product-selection a.close', function( event ) {

            event.preventDefault();
            jQuery( '.product-selection' ).fadeOut( 'fast' );
            return false;

        });

    }
    
});
